import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const FactoryHero = () => {
  const b = useBilingual();
  return (
    <section className="relative h-[480px] md:h-[740px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={asset("/editorial/factory-hero.jpg")}
          alt="Forwaro Factory Floor"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/15" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 pb-16 md:pb-24">
        <p className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-5">
          {b("Factory & Capabilities", "工廠與生產能力")}
        </p>
        <h1
          className="text-3xl md:text-6xl font-bold text-white leading-tight mb-6 max-w-3xl"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b(
            "Built in Dongguan, ready for the world.",
            "Dongguan 製造，為全球市場而生。",
          )}
        </h1>
        <p className="text-white/65 text-base md:text-lg max-w-xl leading-relaxed">
          {b(
            "Forwaro's Dongguan facility integrates joinery, upholstery, finishing and QC under one roof.",
            "Forwaro 東莞廠區將木作、軟包、塗裝與品管整合於同一廠區。",
          )}
          <br />
          {b(
            "Specific capacity figures and certifications are being compiled for publication.",
            "具體產能與認證清單正在整理，將於官網陸續公告。",
          )}
        </p>
      </div>
    </section>
  );
};

export default FactoryHero;
